/**
 * Created by vladislav on 7/10/19
 */

DirtMakerCell.prototype.getMakeDirtDuration = function () {
    return 1500;
};